import 'animate.css/animate.min.css';
import "@fortawesome/fontawesome-pro/css/all.css";
import 'promise-polyfill/src/polyfill';
import VueSSO from '@phila/vue-sso';
import Vue from 'vue';
import App from './App.vue';
import dayjs from './config/dayjs';
import helpers from '@/plugins/helpers';
import router from './router';
import store from './store';
import wording from './config/wording';
import axios from './config/axios';
import notifications from './config/notifications';
import * as PhilaUI from '@phila/phila-ui';
import VModal from 'vue-js-modal';
import TermsAndConditions from '@/components/modals/TermsAndConditions';
import StatusTag from '@/components/common/StatusTag';
import InspectionType from '@/components/common/InspectionType';
import { ClientTable } from 'vue-tables-2';

// Import Edited PhilaUI components
import Dropdown from '@/components/src/phila-ui/components/Inputs/Dropdown/Dropdown';
import Textbox from '@/components/src/phila-ui/components/Inputs/Textbox/Textbox';
import TextArea from '@/components/src/phila-ui/components/Inputs/TextArea/TextArea';
import AppHeader from '@/components/src/phila-ui/components/AppHeader/AppHeader';
import MobileMenu from '@/components/src/phila-ui/components/MobileMenu/MobileMenu';


// Dirty isNaN polyfills
!(typeof Number.isNaN == 'function') ||
  (Number.isNaN = function (value) {
    return value !== null // Number(null) => 0
    && (value != value // NaN != NaN
      || +value != value // Number(falsy) => 0 && falsy == 0...
    );
  });

if (!window.isNaN) {
  window.isNaN = function(value) {
    var n = Number(value);
    return n !== n;
  };
}

store.$router = router;

Vue.use(PhilaUI, {});

Vue.component('Dropdown', Dropdown);
Vue.component('TextArea', TextArea);
Vue.component('Textbox', Textbox);
Vue.component('AppHeader', AppHeader);
Vue.component('StatusTag', StatusTag);
Vue.component('MobileMenu', MobileMenu);
Vue.component('InspectionType', InspectionType);

require('./config/layouts');
require('./config/validation');

Vue.use(ClientTable, {}, false, 'bulma');

Vue.config.productionTip = false;

Vue.use(wording, { store });
Vue.use(helpers, { store });
Vue.use(dayjs, { store });
Vue.use(notifications, { store });
Vue.use(axios, { store });

var b2cScopes = [ `${process.env.VUE_APP_LOGINSCOPE}` ];
var msalConfiguration = {
  clientId: process.env.VUE_APP_CLIENTID,
  redirectUri: process.env.VUE_APP_SSO_REDIRECT,
  dontHandleRedirectAutomatically: true,
  b2cEnvironment: `${process.env.VUE_APP_B2CENVIRONTMENT}`,
  authorityDomain: `${process.env.VUE_APP_AUTHORITYDOMAIN}`,
  signUpSignInPolicy: 'B2C_1A_SIGNUP_SIGNIN',
  resetPasswordPolicy: 'B2C_1A_PASSWORDRESET',
  errorHandler: 'auth/ssoSignInErrorHandler',
  forgotPasswordAction: 'auth/endOfActions',
  debug: process.env.NODE_ENV !== 'production',
  loginRequestScopes: [ "openid", "profile", ...b2cScopes ],
  tokenRequestScopes: [ "profile", ...b2cScopes ],
};

export const createMsalConfiguration = (override) => {
  // get current query parameter called "redirect_url" and assign it to the redirectUri property
  // this is used to redirect the user back to the page they were on before they logged in
  const redirectUri = window.location.search.match(/redirect_url=([^&]+)/);
  if (redirectUri) {
    const customPostbackObject = {
      redirectUrl: redirectUri[1],
    };
    msalConfiguration.state = customPostbackObject;
  }

  return { ...msalConfiguration, ...override };
};

const config = createMsalConfiguration();
Vue.use(VueSSO, { store, config });


Vue.use(VModal, {
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false,
    height: 'auto',
  },
});

Vue.mixin({
  data() {
    return {
      vulcanEnv: process.env.VUE_APP_ENVIRONMENT,
    };
  },
  computed: {
    isAdminPath() {
      if (this.$route.name) {
        return this.$route.name.indexOf('admin') !== -1;
      }
      return 'unknown';
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    openAttentionCases() {
      return this.$store.state.cases.openAttentionCases;
    },
    anyNonOpen() {
      return this.$store.state.cases.anyNonOpen;
    },
  },
  methods: {
    isModalOn($event) {
      document.getElementsByTagName('html')[0].classList.add("modal-open");
      this.$emit('opened', $event);
    },
    isModalOff($event) {
      document.getElementsByTagName('html')[0].classList.remove("modal-open");
      this.$emit("closed", $event);
    },
    async submitGuard(text, params) {
      let ps = params || {};
      return new Promise((resolve) => {
        this.$modal.show('custom-dialog', {
          title: ps.title || this.$wording.home.title_5,
          text,
          buttons: [
            {
              title: 'Yes',
              class: 'yes-button',
              submit: true,
              handler: () => {
                console.log("Hide custom dialog");
                this.$modal.hide('custom-dialog');
                resolve(true);
              },
            },
            {
              title: 'NO',
              default: true,
              class: 'is-dark no-button',
              handler: () => {
                this.$modal.hide('custom-dialog');
                resolve(false);
              },
            },
          ],
          onClosed: () => {
            resolve(false);
          },
          ...ps,
        });
      });
    },
    showPasswordRequirements() {
      this.$modal.show('custom-dialog', {
        title: 'Password requirements',
        text: `
          <p>Passwords must be at least 10 characters long and contain</p>
          <p>
            <ul>
              <li>At least one uppercase letter</li>
              <li>At least one lowercase letter</li>
              <li>At least one number</li>
              <li>At least one special character</li>
            </ul>
          </p>
        `,
        buttons: [],
      });
    },
    showTermsAndConditions() {
      this.$modal.show(TermsAndConditions);
    },
  },
});

// Before doing anything, let's do a health check.
store.dispatch('healthCheck');

// Get zip codes
if (store.state.auth.isAuthenticated) {
  store.dispatch('getZipCodes');
  store.dispatch('getThresholds');
}

Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
